import { ProductItem } from "./ProductItem";

export class ProductTrackingData {
	event: "view_item";
	ecommerce: {
		items: ProductItem[];
	};
	constructor(ecommerce: { items: ProductItem[] }) {
		(this.event = "view_item"), (this.ecommerce = ecommerce);
	}
}
